var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBtcimg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24988",
    "data-name": "Group 24988",
    transform: "translate(-0.325 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8430",
    "data-name": "Ellipse 8430",
    cx: 9.5,
    cy: 9.5,
    r: 9.5,
    transform: "translate(0.325 0)",
    fill: "#f89f36"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42758",
    "data-name": "Path 42758",
    d: "M25.471,6.236a1.4,1.4,0,0,0-.708-1.071,5.917,5.917,0,0,0-.61-.272c.025-.016.041-.033.058-.041A1.668,1.668,0,0,0,24.4,2.191a2.711,2.711,0,0,0-1-.445c-.255-.058-.511-.1-.774-.14,0-.461.008-1.1.008-1.606h-.964c-.008.5-.008,1.12-.016,1.573h-.774c0-.453.008-1.071.008-1.573h-.956c-.008.511-.008,1.145-.016,1.6-.659-.008-1.293-.008-1.952-.016,0,.354-.008.684-.008,1.03.14,0,.264,0,.379.008s.247,0,.362.008a.493.493,0,0,1,.511.544c-.016,1.376-.033,2.76-.041,4.136,0,.3-.132.42-.428.42H18.1c-.066.387-.132.758-.2,1.145l1.952.025c0,.494-.008,1.12-.008,1.639h.964c.008-.519.008-1.129.016-1.615l.774.025c0,.494-.008,1.1-.008,1.6h.964c.008-.519.008-1.129.016-1.606.033-.008.058-.008.082-.016.461-.074.931-.115,1.376-.222a1.815,1.815,0,0,0,1.293-1.063A2.778,2.778,0,0,0,25.471,6.236ZM20.9,2.71a4.056,4.056,0,0,1,1.73.2.79.79,0,0,1,.519.807.83.83,0,0,1-.626.774,4.583,4.583,0,0,1-1.648.14C20.882,4,20.89,3.378,20.9,2.71ZM23,7.521a4.093,4.093,0,0,1-1.664.247c-.157,0-.313-.008-.486-.008l.025-2.134a5.081,5.081,0,0,1,2.142.247A.881.881,0,0,1,23,7.521Z",
    transform: "translate(-12.2 4.188)",
    fill: "#fefefe"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtcimg);
export default __webpack_public_path__ + "static/media/btcimg.a2fe190e69e0c3b78350f4130cddd113.svg";
export { ForwardRef as ReactComponent };